// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 28/02/2024

import { Component } from '@angular/core'
import { BaseController } from './base.controller';
import { ADN_PLUS, Action, ActionType, ApiResponseModel, AuthService, CtDialogComponent, CtFilterContainerComponent, CtFormComponent, CtInputTextComponent, CtRadioComponent, CtTableComponent, CtViewComponent, InputBaseComponent } from 'components';

@Component({
	selector: 'av-vi14',
	template: `<div [id]="getId()" #target><div>`
})

export class AvVi14 extends BaseController {

	private organizationInput: CtInputTextComponent;
	private userIdInput : CtInputTextComponent;
	private numPatronoInput : CtInputTextComponent;

	private readonly ERROR_CODE_DB : string = 'CODE';
	private readonly ERROR_CODE_DB_CREATE_ACCOUNT : string = 'SVA_CREATE_ACCOUNT';
	private readonly ERROR_CODE_DB_NO_ACCOUNT_AND_CONTACTS : string = 'NO_USER_SVA_AND_CONTACTS';
	private readonly MSG_REQUIRED_FIELDS = 'Por favor, complete todos los campos obligatorios antes de enviar el formulario. Los campos marcados con * son requeridos.';
	private readonly MSG_INVALID_ID = 'El dato ingresado para el número de identificación parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.';
	private readonly MSG_INVALID_BIRTHDATE = 'El dato ingresado para la fecha de nacimiento parece incorrecto. Por favor, revise y corrija este dato para continuar.';
	private readonly MSG_INVALID_EMAIL = 'El dato ingresado para correo electrónico institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.';
	private readonly MSG_INVALID_PHONE = 'El dato ingresado para teléfono institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.';
	private readonly VIEW_DESCRIPTION = `Invite asociados del <span class="th-text-main fw-bold">${this.authService.loggedUser.user.organization_name}</span> a hacer uso de la sucursal virtual de la organización.`;

	constructor(private authService : AuthService) {
		super();
		this.setViewCode('AV_VI14');
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	
	public setConstantScreenData(action : Action) {
		this.organizationInput = this.utilService.getComponentRef(action.actionParams[0]);
		this.userIdInput = this.utilService.getComponentRef(action.actionParams[1]);
		this.numPatronoInput = this.utilService.getComponentRef(action.actionParams[2]);
		this.organizationInput.setValue(this.loggedUser.user.organization);
		this.userIdInput.setValue(this.loggedUser.user.user_id);
		this.numPatronoInput.setValue(this.loggedUser.user.organization);
		this.setViewDescripton();
	}

	private setViewDescripton() {
		this.view.setDescription(this.VIEW_DESCRIPTION);
	}

	public onRadioClick(action : Action) {
		const radio : CtRadioComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const input : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
		input.setValue(radio.getValue());
	}

	public manageUserQueryResult(action : Action, result : ADN_PLUS[]){
		const currDialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[3]);
		currDialog.closeDialog();
		if(!this.isUserQueryCorrect(result)) this.manageUnsatisfiedQueryResult(result[0], action);
		else {
			this.utilService.setAdnToAnyComponent(action.actionParams[2], result[0]);
			const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
			const newEvent : Action = new Action('onClick','utl_openDialog',ActionType.VIEW);
			newEvent.actionParams = [dialog.getId()];
			this.componentService.utl_openDialog(newEvent);
		}
	}

	private isUserQueryCorrect(ADN : ADN_PLUS[]): boolean {
		if(ADN[0].ArrayEntities.List[0].Alias === this.ERROR_CODE_DB) return false;
		return true;
	}


	private manageUnsatisfiedQueryResult(ADN : ADN_PLUS, action : Action) {
		const newEvent : Action = new Action('onClick','utl_openDialog',ActionType.VIEW);
		switch(ADN.ArrayEntities.List[0].Value) {

			case this.ERROR_CODE_DB_NO_ACCOUNT_AND_CONTACTS:
				newEvent.actionParams = [action.actionParams[4]];
				break;
			case this.ERROR_CODE_DB_CREATE_ACCOUNT:
				newEvent.actionParams = [action.actionParams[1]];
				break;
			default:

		}
		this.componentService.utl_openDialog(newEvent);
	}

	public checkForValidateUserInputs(action : Action): boolean {
		const form : CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const inputs : CtInputTextComponent[] = form.getFormElements();
		for(const input of inputs) {
			if(input.getValue() == null || input.getValue() === ''){
				this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', 'Debe de completar todos los campos',
				true, 'Aceptar', 'Cancelar');
				return false;
			}
		}
		return true;
	}

	public validacionFormCreate(action: Action): boolean {
		let form: CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
		let elements = form.getFormElements();
		let value = true;
		value = this.formValidation(elements);
		return value;
	}

	private formValidation(elements): boolean {
		for (let element of elements) {
			if (element instanceof InputBaseComponent) {
				if(element.getModelId() === 'TELEFONO' || element.getModelId() === 'CORREO_ELECTRONICO') continue;
				if (this.isFieldEmpty(element)) {
					this.messageValidationForm(this.MSG_REQUIRED_FIELDS);
					return false;
				} else {
					if (!this.validateField(element)) {
						return false;
					}
				}
			}
		}
		return true;
	}
	
	private isFieldEmpty(element: InputBaseComponent): boolean {
		return element.getValue() === '' || element.getValue() === null;
	}

	private messageValidationForm(message): void {
		this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', message, true, 'Aceptar', 'Cancelar');
	}

	private validateField(element: InputBaseComponent): boolean {
		switch (element.getModelId()) {
			case 'DOC_IDENTIFICACION':
				if (element.getValue().length <= 8) {
					this.messageValidationForm(this.MSG_INVALID_ID);
					return false;
				}
				break;
			case 'CORREO':
				if (!this.validationEmail(element)) {
					this.messageValidationForm(this.MSG_INVALID_EMAIL);
					return false;
				}
				break;
			case 'TELEFONO':
				if (element.getValue().length < 8) {
					this.messageValidationForm(this.MSG_INVALID_PHONE);
					return false;
				}
				break;
		}
		return true;
	}

	private validationEmail(element): boolean {
		const pattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		  if(pattern.test(element.getValue())){
			return true;
		  }else return false;
	}

	public manageUserRoleAssignment(action : Action) {
		const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
		dialog.closeDialog();
		const newEvent : Action = new Action('onClick','utl_openDialog',ActionType.VIEW);
		newEvent.actionParams = [action.actionParams[1]];
		const conCtDialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[1]);
		const correo : string = this.getValueFromFormInput(action.actionParams[2]);
    conCtDialog.setDescription(`Se ha asignado la autorización al asociado, por lo cual ahora tendrá acceso a los módulos designados de su institución.`);
		this.componentService.utl_openDialog(newEvent);
		const container : CtFilterContainerComponent
		 = this.utilService.getComponentRef(action.actionParams[3]);
		 const event = container.getEvent('onSearch');
		 container.executeAction2(event);
	}

	private getValueFromFormInput(formId: string): string {
		const ctForm : CtFormComponent = this.utilService.getComponentRef(formId);
		const inputs : CtInputTextComponent[] = ctForm.getFormElements();
		for(const input of inputs) {
			if(input.getModelId() === 'CORREO') return input.getValue();
		}
		return '';
	}
	  
	/* -------------------- END CONTROLLER LOGIC ----------------- */
}
